import Vue from 'vue';
export default Vue.extend({
    name: 'setUpNewSecretPopupChunk',
    data() {
        return {
            form: {
                valid: false,
                fields: {
                    secretCode: {
                        value: '',
                        type: 'password',
                        rules: [
                            (v) => Boolean(v.length) || this.$t('whitelistsPage.errors.fieldIsRequired'),
                            (v) => /^[a-zA-Z0-9]+$/.test(v) || this.$t('whitelistsPage.errors.allowedOnlyLatinSymbols'),
                            (v) => v.length >= 8 || this.$t('whitelistsPage.errors.codeMustContains8Symbols'),
                            (v) => v.search(/[a-z]/g) >= 0 || this.$t('whitelistsPage.errors.codeMustContainsLetters(a-z)'),
                            (v) => v.search(/[A-Z]/g) >= 0 || this.$t('whitelistsPage.errors.codeMustContainsLetters(A-Z)'),
                            (v) => v.search(/[0-9]/g) >= 0 || this.$t('whitelistsPage.errors.codeMustContainsNumbers')
                        ]
                    }
                }
            }
        };
    },
    methods: {
        toggleSecretAppear() {
            const vm = this;
            vm.form.fields.secretCode.type = vm.form.fields.secretCode.type === 'password' ? 'text' : 'password';
        }
    },
    props: {
        slotData: {
            type: Object,
            required: true
        }
    }
});
